export default "__VITE_ASSET__C0a1OMfC__"